import dayjs from '@utils/dayjs';

const isCastingCallEnded = () => {
    const endDate = dayjs('12/06/2023 00:01:00', 'DD/MM/YYYY HH:mm:ss');

    return dayjs().isAfter(endDate);
};

export default isCastingCallEnded;
